import PageElement from './PageElement';
import PageElementPresets from './PageElementPresets';
import PageElementMetaData from './PageElementMetaData';
import PageElementProps from './PageElementProps';

export default {
  metaData: PageElementMetaData,
  elementClass: PageElement,
  elementProps: PageElementProps,
  presets: PageElementPresets
};
